import { Typography } from '@rossum/ui/material';

type ReasoningPreviewProps = {
  value: string;
};

export const ReasoningPreview = ({ value }: ReasoningPreviewProps) => {
  return (
    <Typography
      variant="body2"
      color="text.primary"
      sx={{ whiteSpace: 'pre-wrap', wordBreak: 'break-word' }}
    >
      {value}
    </Typography>
  );
};
